import { IFeature } from '@pro/feature/interface';
import { Input } from 'antd';
import { isPhone } from 'base/utils/client';

const formGridProps = {
    colsPerRow: isPhone ? 1 : 2,
    gutter: 16,
};

export const features: IFeature[] = [
    {
        type: 'titles',
        title: 'Contact',
    },
    {
        type: 'form',
        description: '<p>We are luminaries in LED Grow Light Technology, tailoring solutions to your business needs.</p><p>Reach out to us with inquiries or requests for support.</p>',
        config: {
            apiUrl: '/web/customer-form/contact-us',
            formItems: [
                {
                    type: 'formGrid',
                    typeExtraProps: formGridProps,
                    children: [
                        {
                            formKey: 'firstName',
                            component: <Input placeholder="FIRST NAME"/>,
                            rules: [{ required: true, message: '' }],
                        },
                        {
                            formKey: 'lastName',
                            component: <Input placeholder="LAST NAME"/>,
                            rules: [{ required: true, message: '' }],
                        },
                    ]
                },
                {
                    formKey: 'company',
                    component: <Input placeholder="COMPANY NAME"/>,
                    rules: [{ required: true, message: '' }],
                },
                {
                    type: 'formGrid',
                    typeExtraProps: formGridProps,
                    children: [
                        {
                            formKey: 'email',
                            component: <Input placeholder="EMAIL"/>,
                            rules: [
                                { required: true, message: '' },
                                { type: 'email', message: 'The email you entered is invalid. Please check your email and try again.' }
                            ],
                        },
                        {
                            formKey: 'phoneNumber',
                            component: <Input placeholder="PHONE NUMBER"/>,
                            rules: [{ required: true, message: '' }],
                        },
                    ]
                },
                {
                    type: 'formGrid',
                    typeExtraProps: formGridProps,
                    children: [
                        {
                            formKey: 'country',
                            component: <Input placeholder="COUNTRY"/>,
                            rules: [{ required: true, message: '' }],
                        },
                        {
                            formKey: 'state',
                            component: <Input placeholder="STATE/PROVINCE/CITY"/>,
                            rules: [{ required: true, message: '' }],
                        },
                    ]
                },
                {
                    formKey: 'channel',
                    rules: [{ required: true, message: '' }],
                    component: <Input placeholder="HOW DID YOU HEAR ABOUT US?"/>,
                },
                {
                    formKey: 'message',
                    component: <Input.TextArea placeholder="ADDITIONAL NOTES" maxLength={500} rows={5}/>,
                    rules: [{ required: true, message: '' }],
                },
            ],
            buttonProps: {
                children: 'SUBMIT'
            }
        }
    },
    {
        type: 'productCards',
        title: 'POPULAR PRODUCTS',
        list: [
            'm6',
            'ltl',
            'cb',
        ]
    },
    {
        type: 'popup',
    },
];
